import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { Toast } from 'src/app/interfaces/toast';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToastComponent implements OnInit {
  constructor() {}

  @Input() toast!: Toast;

  onClose() {
    if (this.toast.closeFunction) {
      return this.toast.closeFunction();
    }
  }

  ngOnInit(): void {}
}
